import { grey, red, yellow, blue } from '@mui/material/colors';

export const worstColor = red[500];
export const averageColor = yellow[500];
export const bestColor = blue[500];
export const missingColor = grey[500];
